<template>
  <!-- BEGIN login -->
  <div class="login">
    <!-- BEGIN login-content -->
    <div class="login-content">
      <validation-observer v-slot="{ invalid }">
        <form @submit.prevent="submitLoginRequest">
          <h1 class="text-center">Sign In</h1>
          <div class="text-muted text-center mb-4">
            For your protection, please verify your identity.
          </div>

          <b-alert :show="!!pageError" variant="danger">
            {{ pageError }}
          </b-alert>

          <validation-provider name="Email Address" v-slot="context" rules="required|email">
            <b-form-group label="Email Address" label-for="email-address">
              <b-input
                v-model="email"
                id="email-address"
                type="email"
                size="lg"
                class="fs-15px"
                autocomplete="username"
                placeholder="username@address.com"
                :state="getValidationState(context)"
                aria-describedby="email-address-error"
                v-bind="context.ariaInput"
              />

              <b-form-invalid-feedback id="email-address-error" v-bind="context.ariaMsg">
                {{ context.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider name="Password" rules="required" v-slot="context">
            <b-form-group>
              <div class="d-flex">
                <label for="password">Password</label>
                <b-link a href="#" class="ml-auto text-muted">
                  Forgot password?
                </b-link>
              </div>

              <b-input
                id="password"
                type="password"
                size="lg"
                autocomplete="current-password"
                class="fs-15px"
                placeholder="Enter your password"
                v-model="password"
                :state="getValidationState(context)"
                aria-describedby="password-error"
                v-bind="context.ariaInput"
              />

              <b-form-invalid-feedback id="password-error" v-bind="context.ariaMsg">
                {{ context.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <button type="submit" class="btn btn-primary btn-lg btn-block fw-500 mb-3" :disabled="invalid">
            Sign In
          </button>
        </form>
      </validation-observer>
    </div>
    <!-- END login-content -->
  </div>
  <!-- END login -->
</template>

<script>
import AppOptions from '../config/app-options'
import { getValidationState } from './page-helpers'

export default {
  name: 'LoginPage',
  inject: ['$cannot'],
  data() {
    return { email: '', password: '', pageError: '' }
  },
  mounted() {
    AppOptions.appWithoutSidebar = true
    AppOptions.appWithoutHeader = true
    AppOptions.appContentFullWidth = true
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appWithoutSidebar = false
    AppOptions.appWithoutHeader = false
    AppOptions.appContentFullWidth = false
    next()
  },
  methods: {
    getValidationState,
    async submitLoginRequest() {
      try {
        await this.$store.dispatch('auth/login', {
          email: this.email,
          password: this.password,
        })

        const { roles } = this.$store.getters['auth/user']
        const canAccess = roles.some(role => ['Dashboard User', 'Super Admin'].includes(role))

        if (!canAccess) {
          await this.$store.dispatch('auth/logout')
        }

        this.$router.push({ name: 'dashboard' }, undefined, () => {
          this.$router.go()
        })
      } catch (error) {
        this.pageError = error.code === 'request.unauthorized' ? 'Invalid credentials' : 'Something went wrong'
      }
    },
  },
}
</script>
